

import React, { memo } from 'react';
import { Link, Text } from '../../../../../../../ui-kit';

import '../../../styles/_voice-over-item.scss';








function VoiceOverItem({
  duration,
  wordsCount,
  priceStr,
  openHubSpotConversationsWidget
}) {
  return (
    <div className="voice-over-item">
      <div className="voice-over-item__col">
        <div className="voice-over-item__row">
          <Text heading4>{duration}</Text>
        </div>
        <div className="voice-over-item__row">
          <p>{wordsCount}</p>
        </div>
      </div>
      <div className="voice-over-item__col">
        <div className="voice-over-item__row voice-over-item__row_right">
          {priceStr === 'Speak to us' ?
          <Link
            className="voice-over-item__row_right__link"
            onClick={openHubSpotConversationsWidget}
            buttonProps={{
              id: 'voiceover-speak-to-us'
            }}>

              <Text heading4 success noMargin>
                {priceStr}
              </Text>
            </Link> :

          <Text heading4>{priceStr}</Text>}

        </div>
      </div>
    </div>);

}

export default memo(VoiceOverItem);